import { getAll } from "@/utilities/querySelector";

getAll('[data-filter-toggle]').forEach((filter) => {

    filter.addEventListener('click', (event) => {
        event.preventDefault();
        const target = event.target;
        const filter = target.closest('[data-filter-toggle]');
        const filterId = filter.getAttribute('data-filter-toggle');
        const filterContent = document.querySelector(`[data-filter-content="${filterId}"]`);

        filter.classList.toggle('active');
        filterContent.classList.toggle('active');
    });
});
